import { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ChartWheel from "../components/ChartWheel";
import ShareChartButton from "../components/ShareChartButton";
import { api, SIGN_EN_ES } from "../lib/api";
import ChartPlacements from "../components/ChartPlacements";
import SaveChartCta from "../components/SaveChartCta";
import { useContent } from "../lib/content";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export default function Carta() {
  const { t } = useContent();
  const [form, setForm] = useState({
    name: "",
    email: "",
    birth_date: "",
    birth_time: "12:00",
    birth_place: "",
  });
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/leads/free-chart", form);
      setResult(data);
      toast.success("Tu carta está lista ✦");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo calcular la carta");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="carta-page" className="min-h-screen">
      <Navbar />
      <section className="pt-32 pb-20 max-w-6xl mx-auto px-6">
        <p className="overline mb-3">{t("carta_overline")}</p>
        <h1 className="font-display text-5xl sm:text-6xl text-white font-light tracking-tighter mb-3">
          {t("carta_title")}
        </h1>
        <p className="text-zinc-400 max-w-xl mb-12 leading-relaxed">
          {t("carta_subtitle")}
        </p>

        {!result && (
          <div className="max-w-2xl">
            <div className="mb-8 p-5 border border-[#C9A25E]/20 bg-[#C9A25E]/5">
              <p className="overline mb-1">{t("carta_gate_title")}</p>
              <p className="text-zinc-400 text-sm">{t("carta_gate_body")}</p>
            </div>

            <form onSubmit={submit} data-testid="carta-form" className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="md:col-span-2">
                <label className="field-label">{t("carta_label_name")}</label>
                <input data-testid="carta-name" required className="input-field" value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })} />
              </div>
              <div className="md:col-span-2">
                <label className="field-label">{t("carta_label_email")}</label>
                <input data-testid="carta-email" type="email" required className="input-field" value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })} />
              </div>
              <div>
                <label className="field-label">{t("carta_label_date")}</label>
                <input data-testid="carta-date" type="date" required className="input-field" value={form.birth_date}
                  onChange={(e) => setForm({ ...form, birth_date: e.target.value })} />
              </div>
              <div>
                <label className="field-label">{t("carta_label_time")}</label>
                <input data-testid="carta-time" type="time" required className="input-field" value={form.birth_time}
                  onChange={(e) => setForm({ ...form, birth_time: e.target.value })} />
              </div>
              <div className="md:col-span-2">
                <label className="field-label">{t("carta_label_place")}</label>
                <input data-testid="carta-place" type="text" required placeholder="Ciudad, País"
                  className="input-field" value={form.birth_place}
                  onChange={(e) => setForm({ ...form, birth_place: e.target.value })} />
              </div>
              <div className="md:col-span-2">
                <button data-testid="carta-submit" type="submit" disabled={loading} className="btn-lilac">
                  {loading ? t("carta_loading") : t("carta_submit")}
                </button>
              </div>
            </form>
          </div>
        )}

        {result && (
          <div data-testid="carta-result" className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div className="rise">
              <ChartWheel chart={result.chart} />
              <ShareChartButton chart={result.chart} name={form.name} brand={t("brand_name", "Etérea Enlace")}
                birthLine={`${form.birth_date.split("-").reverse().join("/")} · ${form.birth_time} · ${form.birth_place}`} />
            </div>
            <div className="rise rise-2">
              <p className="overline mb-3">{t("carta_result_title")}</p>
              <h2 className="font-display text-5xl text-white font-light mb-1">
                Tu Sol en Casa {result.sun_house}
              </h2>
              <p className="text-zinc-500 text-sm mb-3">
                Ascendente en {SIGN_EN_ES[result.chart.ascendant.sign]} · Zona horaria {result.chart.timezone}
              </p>
              <p className="text-zinc-600 text-xs mb-8 font-mono">
                Datos usados: {form.birth_date} · {form.birth_time} · {form.birth_place}
              </p>

              {result.interpretation ? (
                <div className="report-prose mb-12">
                  <p>{result.interpretation.body}</p>
                </div>
              ) : (
                <p className="text-zinc-500 italic mb-12">
                  La interpretación para esta posición aún no está en la biblioteca.
                </p>
              )}

              <ChartPlacements chart={result.chart} />

              <SaveChartCta form={form} />

              <div className="p-8 border border-[#C9A25E]/30 bg-[#C9A25E]/5">
                <p className="overline mb-2">{t("carta_unlock_title")}</p>
                <p className="text-white mb-4 font-display text-2xl">
                  {t("carta_unlock_body")}
                </p>
                <Link to="/solicitar" data-testid="carta-to-solicitar" className="btn-lilac">
                  {t("carta_unlock_cta")} ✦
                </Link>
              </div>
            </div>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
